import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
export class ExternalLayoutHandler extends AbstractExternalAPIHandler {
  applyComponentResize(editorPointer, type, componentInitialSize) {
    var _this$hostAPI$editor$, _this$hostAPI$editor;
    const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
    const layout = (_this$hostAPI$editor$ = (_this$hostAPI$editor = this.hostAPI.editor).generateComponentLayout) == null ? void 0 : _this$hostAPI$editor$.call(_this$hostAPI$editor, {
      componentInitialSize
    });
    if (layout) {
      this.dm.components.responsiveLayout.update(contextualEditorPointer.documentPointer, layout);
    } else {
      console.error('generateComponentLayout is not available in host API', editorPointer, type, componentInitialSize);
    }
  }
}
//# sourceMappingURL=ExternalLayoutHandler.js.map